import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { RootState } from "../../store";
import { useEffect, useRef, useState } from "react";

function Navigation() {
    const baseClasses = "cursor-pointer hover:text-accent";
    const activeClass = "text-accent";
    const { user } = useSelector((state: RootState) => state.auth);
    // const isNotStuding = !user?.roles.includes("student") || user?.roles.includes("teacher") || user?.roles.includes("student_management") || user?.roles.includes("branch_manager");
    const isStudent = user?.roles.includes("student");
    const isManagement = user?.roles.includes("student_management") || user?.roles.includes("branch_manager");
    const isStaff = user?.roles.includes("student_management") || user?.roles.includes("teacher") || user?.roles.includes("branch_manager") || user?.roles.includes("staff") || user?.roles.includes("admin");
    const isTeacher = user?.roles.includes("teacher");
    const [openDropdown, setOpenDropdown] = useState(false);
    const dropdownRef = useRef<HTMLLIElement>(null);
 
    // Đóng dropdown khi click ra ngoài
    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    
    return (
        <nav>
            <ul className="text-white font-medium text-[16px] flex flex-wrap justify-center gap-x-[20px] gap-y-[10px]">
                <li>
                    <NavLink
                        to="/"
                        className={({ isActive }) =>
                            `${baseClasses} ${isActive ? activeClass : ""}`
                        }
                    >
                        Trang chủ
                    </NavLink>
                </li>
                {user && (
                    <li>
                        <NavLink
                            to="/profile"
                            className={({ isActive }) =>
                                `${baseClasses} ${isActive ? activeClass : ""}`
                            }
                        >
                            {isStudent ? "Hồ sơ học sinh" : "Hồ sơ"}
                        </NavLink>
                    </li>
                )}
                {!isTeacher && 
                (<li>
                    <NavLink
                        to="/course"
                        className={({ isActive }) =>
                            `${baseClasses} ${isActive ? activeClass : ""}`
                        }
                    >
                        Khóa học
                    </NavLink>
                </li>)}
                {user && isStaff && (
                    <><li>
                        <NavLink
                            to="/class"
                            className={({ isActive }) => `${baseClasses} ${isActive ? activeClass : ""}`}
                        >
                            Lớp học
                        </NavLink>
                    </li><li>
                            <NavLink
                                to="/lession"
                                className={({ isActive }) => `${baseClasses} ${isActive ? activeClass : ""}`}
                            >
                                Bài giảng
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/document"
                                className={({ isActive }) => `${baseClasses} ${isActive ? activeClass : ""}`}
                            >
                                Tài liệu
                            </NavLink>
                        </li>
                        {isManagement && (<li>
                            <NavLink
                                to="/list-student-register"
                                className={({ isActive }) => `${baseClasses} ${isActive ? activeClass : ""}`}
                            >
                                Quản lý học sinh
                            </NavLink>
                        </li>)}
                    </>
                )}
                {!user && <li>
                    <NavLink
                        to="/register"
                        className={({ isActive }) =>
                            `${baseClasses} ${isActive ? activeClass : ""}`
                        }
                    >
                        Đăng ký học
                    </NavLink>
                </li>
                }
                                {/* Dịch vụ khác — có dropdown */}
                <li ref={dropdownRef} className="relative">
                    <button
                        onClick={() => setOpenDropdown((prev) => !prev)}
                        className={`${baseClasses} flex items-center gap-1`}
                    >
                        Dịch vụ khác
                        <svg
                            className={`w-3.5 h-3.5 transition-transform duration-200 ${openDropdown ? "rotate-180" : ""}`}
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
 
                    {openDropdown && (
                        <ul className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-52 bg-white rounded-lg shadow-lg overflow-hidden z-50">
                            <li>
                                <NavLink
                                    to="/other-services"
                                    end
                                    onClick={() => setOpenDropdown(false)}
                                    className={({ isActive }) =>
                                        `block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-100 hover:text-accent ${isActive ? "text-accent font-semibold" : ""}`
                                    }
                                >
                                    Tất cả dịch vụ
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/other-services/laptop-rental"
                                    onClick={() => setOpenDropdown(false)}
                                    className={({ isActive }) =>
                                        `block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-100 hover:text-accent ${isActive ? "text-accent font-semibold" : ""}`
                                    }
                                >
                                    Dịch vụ cho thuê laptop
                                </NavLink>
                            </li>
                        </ul>
                    )}
                </li>

            </ul>
        </nav>
    );
}

export default Navigation;
